var pixi_ui;
(function (pixi_ui) {
    var component;
    (function (component) {
        component.Viewport = require('pixi-viewport');
        var Scroll = (function () {
            function Scroll(direction, friction) {
                this.viewport = new component.Viewport({
                    noTicker: true,
                });
                this.viewport
                    .drag({ direction: direction, wheel: false })
                    .decelerate({ friction: friction })
                    .clamp({ direction: 'all' });
            }
            Scroll.prototype.onViewportMove = function (element) {
                element.children.forEach(function (child) {
                    if (child instanceof pixi_ui.Element) {
                        child.setPosition();
                    }
                });
            };
            Scroll.prototype.attach = function (element) {
                element.addChild(this.viewport);
                this.setChildParentScroll(element, this);
                this.onViewportMove = this.onViewportMove.bind(this, element);
                this.viewport.on('moved', this.onViewportMove);
            };
            Scroll.prototype.detach = function (element) {
                element.removeChild(this.viewport);
                this.setChildParentScroll(element, null);
                this.viewport.off('moved', this.onViewportMove);
            };
            Scroll.prototype.resize = function (element) {
                this.setChildParentScroll(element, this);
                this.viewport.resize(element.elementWidth, element.elementHeight, element.elementWidth, Math.max(element.elementHeight, element.contentHeight));
                this.onViewportMove(element);
            };
            Scroll.prototype.setChildParentScroll = function (element, scroll) {
                element.children.forEach(function (child) {
                    if (child instanceof pixi_ui.Element) {
                        child.parentScroll = scroll;
                    }
                });
            };
            return Scroll;
        }());
        component.Scroll = Scroll;
    })(component = pixi_ui.component || (pixi_ui.component = {}));
})(pixi_ui || (pixi_ui = {}));
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var pixi_ui;
(function (pixi_ui) {
    var Container = PIXI.Container;
    var Point = PIXI.Point;
    var ObservablePoint = PIXI.ObservablePoint;
    var ElementType;
    (function (ElementType) {
        ElementType[ElementType["group"] = 0] = "group";
        ElementType[ElementType["image"] = 1] = "image";
        ElementType[ElementType["nineslice"] = 2] = "nineslice";
        ElementType[ElementType["text"] = 3] = "text";
        ElementType[ElementType["button"] = 4] = "button";
        ElementType[ElementType["json"] = 5] = "json";
        ElementType[ElementType["rect"] = 6] = "rect";
    })(ElementType = pixi_ui.ElementType || (pixi_ui.ElementType = {}));
    var Element = (function (_super) {
        __extends(Element, _super);
        function Element() {
            var _this = _super.call(this) || this;
            _this.components = [];
            _this.anchorTopLeft = new ObservablePoint(_this.setPosition, _this, 0.5, 0.5);
            _this.anchorBottomRight = new ObservablePoint(_this.setPosition, _this, 0.5, 0.5);
            _this.offsetTopLeft = new ObservablePoint(_this.setPosition, _this);
            _this.offsetBottomRight = new ObservablePoint(_this.setPosition, _this);
            _this.elementPivot = new ObservablePoint(_this.setPivot, _this, 0.5, 0.5);
            _this.elementWidth = 100;
            _this.elementHeight = 100;
            _this.contentWidth = 1;
            _this.contentHeight = 1;
            return _this;
        }
        Object.defineProperty(Element.prototype, "elementWidth", {
            get: function () {
                return this._elementWidth;
            },
            set: function (value) {
                this._elementWidth = value;
                this.setPivot();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Element.prototype, "elementHeight", {
            get: function () {
                return this._elementHeight;
            },
            set: function (value) {
                this._elementHeight = value;
                this.setPivot();
            },
            enumerable: true,
            configurable: true
        });
        Element.prototype.setPivot = function () {
            this.pivot.set(this.elementWidth * this.elementPivot.x, this.elementHeight * this.elementPivot.y);
        };
        Element.prototype.setPosition = function () {
            this.position = this.getPosition();
        };
        Element.prototype.getAnchorCenter = function () {
            return new Point(((this.anchorTopLeft.x + this.anchorBottomRight.x) / 2) *
                this.parentWidth, ((this.anchorTopLeft.y + this.anchorBottomRight.y) / 2) *
                this.parentHeight);
        };
        Element.prototype.getSize = function () {
            return new Point(this.elementWidth + this.offsetTopLeft.x - this.offsetBottomRight.x, this.elementHeight + this.offsetTopLeft.y - this.offsetBottomRight.y);
        };
        Element.prototype.getPosition = function () {
            var anchorCenter = this.getAnchorCenter();
            var newPosition = new Point(anchorCenter.x - this.offsetTopLeft.x, anchorCenter.y - this.offsetTopLeft.y);
            if (this.parentScroll) {
                newPosition.x += this.parentScroll.viewport.x;
                newPosition.y += this.parentScroll.viewport.y;
            }
            return newPosition;
        };
        Element.prototype.add = function (component) {
            component.attach(this);
            this.components.push(component);
        };
        Element.prototype.remove = function (component) {
            var index = this.components.indexOf(component);
            if (index !== -1) {
                this.components.splice(index, 1);
                component.detach(this);
            }
        };
        Element.prototype.resize = function (width, height) {
            var _this = this;
            this.elementWidth =
                (this.desiredWidth || width) +
                    this.offsetTopLeft.x -
                    this.offsetBottomRight.x;
            this.elementHeight =
                (this.desiredHeight || height) +
                    this.offsetTopLeft.y -
                    this.offsetBottomRight.y;
            if (this.widthMin)
                this.elementWidth = Math.max(this.elementWidth, this.widthMin);
            if (this.widthMax)
                this.elementWidth = Math.min(this.elementWidth, this.widthMax);
            if (this.heightMin)
                this.elementHeight = Math.max(this.elementHeight, this.heightMin);
            if (this.heightMax)
                this.elementHeight = Math.min(this.elementHeight, this.heightMax);
            this.position = this.getPosition();
            if (this.parent && this.parent instanceof Element) {
                this.parentWidth = this.parent.elementWidth;
                this.parentHeight = this.parent.elementHeight;
            }
            else {
                this.parentWidth = width;
                this.parentHeight = height;
            }
            this.contentWidth = this.elementWidth;
            this.contentHeight = this.elementHeight;
            this.children.forEach(function (child) {
                if (child instanceof Element) {
                    child.resize(_this.elementWidth, _this.elementHeight);
                    var px = child.x | 0;
                    _this.contentWidth = Math.max(_this.contentWidth, px + child.contentWidth * (1 - child.elementPivot.x));
                    var py = child.y | 0;
                    _this.contentHeight = Math.max(_this.contentHeight, py + child.contentHeight * (1 - child.elementPivot.y));
                }
            });
            this.components.forEach(function (component) { return component.resize(_this); });
        };
        return Element;
    }(Container));
    pixi_ui.Element = Element;
})(pixi_ui || (pixi_ui = {}));
var pixi_ui;
(function (pixi_ui) {
    PIXI.ui = pixi_ui;
})(pixi_ui || (pixi_ui = {}));
var pixi_ui;
(function (pixi_ui) {
    var component;
    (function (component) {
        var Sprite = PIXI.Sprite;
        var Image = (function () {
            function Image(texture) {
                this.imageSprite = new Sprite(texture);
            }
            Image.prototype.attach = function (element) {
                element.desiredWidth = this.imageSprite.width;
                element.desiredHeight = this.imageSprite.height;
                element.addChild(this.imageSprite);
            };
            Image.prototype.detach = function (element) {
                element.removeChild(this.imageSprite);
            };
            Image.prototype.resize = function (element) {
                this.imageSprite.width = element.elementWidth;
                this.imageSprite.height = element.elementHeight;
            };
            return Image;
        }());
        component.Image = Image;
    })(component = pixi_ui.component || (pixi_ui.component = {}));
})(pixi_ui || (pixi_ui = {}));
var pixi_ui;
(function (pixi_ui) {
    var component;
    (function (component) {
        var Input = (function () {
            function Input(enabled) {
                this.enabled = enabled;
            }
            Input.prototype.attach = function (element) {
                element.interactive = this.enabled;
                element.buttonMode = this.enabled;
            };
            Input.prototype.detach = function (element) {
                element.interactive = false;
                element.buttonMode = false;
            };
            Input.prototype.resize = function (element) { };
            return Input;
        }());
        component.Input = Input;
    })(component = pixi_ui.component || (pixi_ui.component = {}));
})(pixi_ui || (pixi_ui = {}));
var pixi_ui;
(function (pixi_ui) {
    var component;
    (function (component) {
        var Graphics = PIXI.Graphics;
        var Mask = (function () {
            function Mask(offset) {
                this.graphics = new Graphics();
                this.offset = offset;
            }
            Mask.prototype.attach = function (element) {
                this.graphics.beginFill(0, 1);
                this.graphics.drawRect(0, 0, Math.abs(element.elementWidth - this.offset.right - this.offset.left), Math.abs(element.elementHeight - this.offset.bottom - this.offset.top));
                this.graphics.endFill();
                this.graphics.x = this.offset.left;
                this.graphics.y = this.offset.top;
                element.addChild(this.graphics);
                element.mask = this.graphics;
            };
            Mask.prototype.detach = function (element) {
                element.mask = null;
                element.removeChild(this.graphics);
            };
            Mask.prototype.resize = function (element) {
                this.graphics.clear();
                this.graphics.beginFill(0, 1);
                this.graphics.drawRect(0, 0, Math.abs(element.elementWidth - this.offset.right), Math.abs(element.elementHeight - this.offset.bottom));
                this.graphics.endFill();
            };
            return Mask;
        }());
        component.Mask = Mask;
    })(component = pixi_ui.component || (pixi_ui.component = {}));
})(pixi_ui || (pixi_ui = {}));
var pixi_ui;
(function (pixi_ui) {
    var component;
    (function (component) {
        var NineSlicePlane = PIXI.mesh.NineSlicePlane;
        var NineSlice = (function () {
            function NineSlice(texture, nineSliceOffset) {
                this.nineSlicePlane = new NineSlicePlane(texture, nineSliceOffset.left, nineSliceOffset.top, nineSliceOffset.right, nineSliceOffset.bottom);
            }
            NineSlice.prototype.attach = function (element) {
                this.nineSlicePlane.width = element.elementWidth;
                this.nineSlicePlane.height = element.elementHeight;
                element.addChild(this.nineSlicePlane);
            };
            NineSlice.prototype.detach = function (element) {
                element.removeChild(this.nineSlicePlane);
            };
            NineSlice.prototype.resize = function (element) {
                this.nineSlicePlane.width = element.elementWidth;
                this.nineSlicePlane.height = element.elementHeight;
            };
            return NineSlice;
        }());
        component.NineSlice = NineSlice;
    })(component = pixi_ui.component || (pixi_ui.component = {}));
})(pixi_ui || (pixi_ui = {}));
var pixi_ui;
(function (pixi_ui) {
    var component;
    (function (component) {
        var Sprite = PIXI.Sprite;
        var Texture = PIXI.Texture;
        var Rect = (function () {
            function Rect(color, alpha) {
                this.color = 0xffffff;
                this.alpha = 1.0;
                this.color = color;
                this.alpha = alpha;
                this.sprite = new Sprite(Texture.WHITE);
            }
            Rect.prototype.attach = function (element) {
                this.sprite.tint = this.color;
                this.sprite.alpha = this.alpha;
                this.sprite.width = element.contentWidth;
                this.sprite.height = element.contentHeight;
                element.addChild(this.sprite);
            };
            Rect.prototype.detach = function (element) {
                element.removeChild(this.sprite);
            };
            Rect.prototype.resize = function (element) {
                this.sprite.width = element.contentWidth;
                this.sprite.height = element.contentHeight;
            };
            return Rect;
        }());
        component.Rect = Rect;
    })(component = pixi_ui.component || (pixi_ui.component = {}));
})(pixi_ui || (pixi_ui = {}));
var pixi_ui;
(function (pixi_ui) {
    var component;
    (function (component) {
        var Graphics = PIXI.Graphics;
        var RoundedRect = (function () {
            function RoundedRect(color, alpha, radius) {
                this.color = color;
                this.alpha = alpha;
                this.radius = radius;
                this.rect = new Graphics();
            }
            RoundedRect.prototype.attach = function (element) {
                this.rect.beginFill(this.color, this.alpha);
                this.rect.drawRoundedRect(0, 0, element.contentWidth, element.contentHeight, this.radius);
                element.addChild(this.rect);
            };
            RoundedRect.prototype.detach = function (element) {
                element.removeChild(this.rect);
            };
            RoundedRect.prototype.resize = function (element) {
                this.rect.clear();
                this.rect.beginFill(this.color, this.alpha);
                this.rect.drawRoundedRect(0, 0, element.contentWidth, element.contentHeight, this.radius);
            };
            return RoundedRect;
        }());
        component.RoundedRect = RoundedRect;
    })(component = pixi_ui.component || (pixi_ui.component = {}));
})(pixi_ui || (pixi_ui = {}));
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var pixi_ui;
(function (pixi_ui) {
    var component;
    (function (component) {
        var defaultTextStyleOptions = {
            fontSize: 22,
            fontFamily: 'arial',
            fill: 0x000000,
        };
        var Text = (function () {
            function Text(text, textStyleOptions) {
                var options = __assign({}, defaultTextStyleOptions, textStyleOptions);
                this.PIXIText = new PIXI.Text(text, options);
                this._text = text;
            }
            Object.defineProperty(Text.prototype, "text", {
                get: function () {
                    return this._text;
                },
                set: function (text) {
                    this._text = text;
                    this.PIXIText.text = text;
                },
                enumerable: true,
                configurable: true
            });
            Text.prototype.attach = function (element) {
                element.desiredWidth = this.PIXIText.width;
                element.desiredHeight = this.PIXIText.height;
                element.addChild(this.PIXIText);
            };
            Text.prototype.detach = function (element) {
                element.removeChild(this.PIXIText);
            };
            Text.prototype.resize = function (element) {
                element.desiredWidth = this.PIXIText.width;
                element.desiredHeight = this.PIXIText.height;
            };
            return Text;
        }());
        component.Text = Text;
    })(component = pixi_ui.component || (pixi_ui.component = {}));
})(pixi_ui || (pixi_ui = {}));
var pixi_ui;
(function (pixi_ui) {
    var component;
    (function (component) {
        var Transparency = (function () {
            function Transparency(alpha) {
                this.alpha = alpha;
            }
            Transparency.prototype.attach = function (element) {
                element.alpha = this.alpha;
            };
            Transparency.prototype.detach = function (element) {
                element.alpha = 1;
            };
            Transparency.prototype.resize = function (element) { };
            return Transparency;
        }());
        component.Transparency = Transparency;
    })(component = pixi_ui.component || (pixi_ui.component = {}));
})(pixi_ui || (pixi_ui = {}));
var pixi_ui;
(function (pixi_ui) {
    var component;
    (function (component) {
        var VerticalGroup = (function () {
            function VerticalGroup(padding, spacing) {
                this.padding = padding;
                this.spacing = spacing;
            }
            VerticalGroup.prototype.attach = function (element) { };
            VerticalGroup.prototype.detach = function (element) { };
            VerticalGroup.prototype.resize = function (element) {
                var _this = this;
                var py = -this.padding.top;
                element.children.forEach(function (child) {
                    if (child instanceof pixi_ui.Element) {
                        child.offsetTopLeft.y = py;
                        child.offsetBottomRight.y = py;
                        py -= (child.contentHeight + _this.spacing);
                    }
                });
                element.contentHeight =
                    Math.abs(py) - this.spacing + this.padding.bottom;
            };
            return VerticalGroup;
        }());
        component.VerticalGroup = VerticalGroup;
    })(component = pixi_ui.component || (pixi_ui.component = {}));
})(pixi_ui || (pixi_ui = {}));
var pixi_ui;
(function (pixi_ui) {
    var component;
    (function (component) {
        var Visibility = (function () {
            function Visibility(hidden) {
                this.hidden = hidden;
            }
            Visibility.prototype.attach = function (element) {
                element.visible = this.hidden;
            };
            Visibility.prototype.detach = function (element) {
                element.visible = true;
            };
            Visibility.prototype.resize = function (element) { };
            return Visibility;
        }());
        component.Visibility = Visibility;
    })(component = pixi_ui.component || (pixi_ui.component = {}));
})(pixi_ui || (pixi_ui = {}));
var pixi_ui;
(function (pixi_ui) {
    var utility;
    (function (utility) {
        var Image = pixi_ui.component.Image;
        var Text = pixi_ui.component.Text;
        var NineSlice = pixi_ui.component.NineSlice;
        var Input = pixi_ui.component.Input;
        var Rect = pixi_ui.component.Rect;
        var Transparency = pixi_ui.component.Transparency;
        var Visibility = pixi_ui.component.Visibility;
        var DefaultBuilder = (function () {
            function DefaultBuilder() {
            }
            DefaultBuilder.prototype.create = function (data) {
                if (!data.rootElement)
                    throw "Key 'rootElement' missing is JSON.";
                var rootElement = this.generateElement(data.rootElement);
                return rootElement;
            };
            DefaultBuilder.prototype.generateElement = function (elementData) {
                var _this = this;
                var element = new pixi_ui.Element();
                element.name = elementData.name;
                element.type = pixi_ui.ElementType[elementData.type];
                if (elementData.layout.constrains) {
                    element.widthMax = elementData.layout.constrains.widthMax;
                    element.widthMin = elementData.layout.constrains.widthMin;
                    element.heightMax = elementData.layout.constrains.heightMax;
                    element.heightMin = elementData.layout.constrains.heightMin;
                }
                if (elementData.layout.pivot) {
                    element.pivot.set(elementData.layout.pivot[0], elementData.layout.pivot[1]);
                }
                if (elementData.layout.anchors) {
                    element.anchorTopLeft.set(elementData.layout.anchors[0], elementData.layout.anchors[1]);
                    element.anchorBottomRight.set(elementData.layout.anchors[2], elementData.layout.anchors[3]);
                }
                if (elementData.layout.offsets) {
                    element.offsetTopLeft.set(elementData.layout.offsets[0], elementData.layout.offsets[1]);
                    element.offsetBottomRight.set(elementData.layout.offsets[2], elementData.layout.offsets[3]);
                }
                if (elementData.layout.angle) {
                    element.rotation = elementData.layout.angle;
                }
                if (elementData.components && elementData.components.length > 0) {
                    elementData.components.map(function (componentData) {
                        element.add(_this.generateComponent(componentData));
                    });
                }
                if (elementData.children && elementData.children.length > 0) {
                    elementData.children.map(function (elementData) {
                        element.addChild(_this.generateElement(elementData));
                    });
                }
                return element;
            };
            DefaultBuilder.prototype.generateComponent = function (componentData) {
                if (componentData.type === undefined)
                    'Component type not specified.';
                var component;
                var atlas = PIXI.loader.resources['atlas_1'];
                var texture;
                switch (componentData.type) {
                    case 'image':
                        texture = atlas.textures[componentData.data.cacheKey];
                        return new Image(texture);
                        break;
                    case 'nineslice':
                        texture = atlas.textures[componentData.data.cacheKey];
                        return new NineSlice(texture, {
                            top: componentData.data.offset[0],
                            right: componentData.data.offset[1],
                            bottom: componentData.data.offset[2],
                            left: componentData.data.offset[3],
                        });
                        break;
                    case 'text':
                        var options = {};
                        var style = componentData.data.style;
                        if (style) {
                            if (style.style)
                                options.fontStyle = style.style;
                            if (style.font)
                                options.fontFamily = style.font;
                            if (style.fontSize)
                                options.fontSize = style.fontSize;
                            if (style.fill)
                                options.fill = style.fill;
                            if (style.stroke)
                                options.stroke = style.stroke;
                            if (style.strokeThickness)
                                options.strokeThickness = style.strokeThickness;
                            if (style.lineSpacing)
                                options.lineHeight = style.lineSpacing;
                            if (componentData.data.align)
                                options.align = componentData.data.align;
                            if (componentData.data.textWrap)
                                options.wordWrap = componentData.data.textWrap;
                            if (componentData.data.maxWidth)
                                options.wordWrapWidth = componentData.data.maxWidth;
                        }
                        return new Text(this.getTextLocalized(componentData.data.textLocalizationKey), options);
                        break;
                    case 'input':
                        return new Input(componentData.data.enabled);
                        break;
                    case 'rect':
                        return new Rect(componentData.data.color[2] |
                            (componentData.data.color[1] << 8) |
                            (componentData.data.color[0] << 16), componentData.data.color[3] / 255);
                        break;
                    case 'transparency':
                        return new Transparency(componentData.data.alpha);
                        break;
                    case 'visibility':
                        return new Visibility(componentData.data.hidden);
                        break;
                }
                throw "Component type " + componentData.type + " not implemented.";
            };
            DefaultBuilder.prototype.getTextLocalized = function (textLocalizationKey) {
                return "" + textLocalizationKey;
            };
            DefaultBuilder.prototype.getTexture = function (cacheKey) {
                return PIXI.Texture.WHITE;
            };
            return DefaultBuilder;
        }());
        utility.DefaultBuilder = DefaultBuilder;
    })(utility = pixi_ui.utility || (pixi_ui.utility = {}));
})(pixi_ui || (pixi_ui = {}));
var pixi_ui;
(function (pixi_ui) {
    var utility;
    (function (utility) {
        var DefaultBuilder = pixi_ui.utility.DefaultBuilder;
        var UIFactory = (function () {
            function UIFactory() {
            }
            UIFactory.createUI = function (data, driver) {
                var builder = driver || new DefaultBuilder();
                var rootElement = builder.create(data);
                return rootElement;
            };
            return UIFactory;
        }());
        utility.UIFactory = UIFactory;
    })(utility = pixi_ui.utility || (pixi_ui.utility = {}));
})(pixi_ui || (pixi_ui = {}));
//# sourceMappingURL=pixi-ui.js.map